import React, { useContext, useEffect } from 'react';
import moment from 'moment-timezone';
import ReferralStatistics from '../../composed/referralStatistics/ReferralStatistics';
import { RevenueSharingContext } from '../../context-api/data-provider/RevenueSharingDataProvider';
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';

const ReferralStatisticsPage = () => {
  const {
    revenueSharingAPIResponse,
    onRevenueSharingDataAPI,
    onGoogleAnalyticDataAPI,
    googleAnalyticAPIResponse,
  } = useContext(RevenueSharingContext);
  const { onLoadInfoResponse, isLoggedIn } = useContext(GlobalStateDataContext);
  const KitchenName = onLoadInfoResponse?.data?.data?.data?.KitchenInfo?.kitchenName;
  const ApiFetchedDate = revenueSharingAPIResponse?.data?.data?.fetchApiDate;
  const KitchenTimeZone = revenueSharingAPIResponse?.data?.data?.timeZone || 'America/Chicago';
  const UrlVisitPromoCodeTrack =
    onLoadInfoResponse?.data?.data?.data?.kitchenOperationObject?.promo_tracking_code;
  const todaysDate = moment().format('YYYY/MM/DD'); // This format is google analytic only
  const ApiFetchedGoogleDate = googleAnalyticAPIResponse?.data?.data?.fetchApiDate;

  function isDateToday(dateStr, timeZone) {
    return moment.tz(dateStr, 'MM/DD/YYYY', timeZone).isSame(moment().tz(timeZone), 'day');
  }

  const firstDateofCurrentMonth = moment(todaysDate, 'YYYY-MM-DD')
    .startOf('month')
    .format('YYYY-MM-DD');

  // I will pass to GA api  { "startDate": firstDateofCurrentMonth,  //  "promo": [UrlVisitPromoCodeTrack] }

  useEffect(() => {
    if (isLoggedIn && !isDateToday(ApiFetchedDate, KitchenTimeZone)) {
      const payloadData = { account_id: KitchenName };
      onRevenueSharingDataAPI(payloadData);
    }
  }, []);

  // Google Anayalictic call
  useEffect(() => {
    if (
      isLoggedIn &&
      !isDateToday(ApiFetchedGoogleDate, KitchenTimeZone) &&
      UrlVisitPromoCodeTrack !== undefined
    ) {
      const payloadData = {
        startDate: firstDateofCurrentMonth,
        store_name: KitchenName,
        promo: [UrlVisitPromoCodeTrack],
      };
      onGoogleAnalyticDataAPI(payloadData);
    }
  }, []);

  return (
    <div>
      ReferralStatistics Page coming soon
      <ReferralStatistics redirect={false} />
    </div>
  );
};

export default ReferralStatisticsPage;
